/**
 * Snippets API
 * Here is the API DNA
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Rule {
  readonly id?: number;
  ref: string;
  sortKey?: number;
  operator: Rule.OperatorEnum;
  notFoundOk?: boolean;
  exactMatch?: boolean;
  explanation?: string;
  explanationFr?: string;
  explanationNl?: string;
  fetchRank?: number;
  popup?: boolean;
  popupText?: string;
  popupTextFr?: string;
  popupTextNl?: string;
  explanationPopup?: string;
  explanationPopupFr?: string;
  explanationPopupNl?: string;
  varLeftConfidenceThreshold?: number;
  varRightConfidenceThreshold?: number;
  matchRestrictedToSameEntity?: boolean;
  filterFromParentRule?: boolean;
  displayOperator?: Rule.DisplayOperatorEnum;
  ruleType?: Rule.RuleTypeEnum;
  varLeft: number;
  varRight?: number;
  constant?: number;
  triggerRule?: number;
  prerequisites?: Array<number>;
  tags?: Array<number>;
}
export namespace Rule {
  export type OperatorEnum = 'GT' | 'LT' | 'EQ' | 'NE' | 'SIM' | 'GTE' | 'LTE' | 'IN' | 'NIN' | 'EXI' | 'NULL' | 'CONT';
  export const OperatorEnum = {
    GT: 'GT' as OperatorEnum,
    LT: 'LT' as OperatorEnum,
    EQ: 'EQ' as OperatorEnum,
    NE: 'NE' as OperatorEnum,
    SIM: 'SIM' as OperatorEnum,
    GTE: 'GTE' as OperatorEnum,
    LTE: 'LTE' as OperatorEnum,
    IN: 'IN' as OperatorEnum,
    NIN: 'NIN' as OperatorEnum,
    EXI: 'EXI' as OperatorEnum,
    NULL: 'NULL' as OperatorEnum,
    CONT: 'CONT' as OperatorEnum,
  };
  export type DisplayOperatorEnum =
    | 'GT'
    | 'LT'
    | 'EQ'
    | 'NE'
    | 'SIM'
    | 'GTE'
    | 'LTE'
    | 'IN'
    | 'NIN'
    | 'EXI'
    | 'NULL'
    | 'CONT';
  export const DisplayOperatorEnum = {
    GT: 'GT' as DisplayOperatorEnum,
    LT: 'LT' as DisplayOperatorEnum,
    EQ: 'EQ' as DisplayOperatorEnum,
    NE: 'NE' as DisplayOperatorEnum,
    SIM: 'SIM' as DisplayOperatorEnum,
    GTE: 'GTE' as DisplayOperatorEnum,
    LTE: 'LTE' as DisplayOperatorEnum,
    IN: 'IN' as DisplayOperatorEnum,
    NIN: 'NIN' as DisplayOperatorEnum,
    EXI: 'EXI' as DisplayOperatorEnum,
    NULL: 'NULL' as DisplayOperatorEnum,
    CONT: 'CONT' as DisplayOperatorEnum,
  };
  export type RuleTypeEnum = 'STANDARD' | 'ADVICE';
  export const RuleTypeEnum = {
    STANDARD: 'STANDARD' as RuleTypeEnum,
    ADVICE: 'ADVICE' as RuleTypeEnum,
  };
}
